__turbopack_context__.v({
  "center-box": "maintenance-module-scss-module__VIk7aW__center-box",
});
